import { BaseLocalDataInfos } from "../base/BaseLocalData";

export default class DebugData extends BaseLocalDataInfos {

    bHitCowDebug: boolean = false;
    // getLocalDataKey() {
    //     return FileKind.SaveLocalDataKey.MILITARY_CITY_DATA;
    // }
}
